<div [ngClass]="CombineStyle(style, type)" (click)="onClickEvent()">
  <a *ngIf="removeable" class="close" (click)="onRemoveEvent()">x</a>
  <ng-content></ng-content>
</div>
